import shared from "emun.cust/details/cust-details.states.es6";

const {
  overview,
  profile,
  shipTo,
  paymentMethods,
  vendorInfo,
  orders,
  //invoices,
  itemHistory,
  //   creditmemos,
  // documents,
  // paymentHistory,
  //changeLog,
  forms,
  //   users,
} = shared;

export default {
  overview,
  profile,
  shipTo,
  paymentMethods,
  vendorInfo,
  orders,
  //invoices,
  itemHistory,
  //   creditmemos,
  // documents,
  // paymentHistory,
  forms,
  //changeLog,
  //   users,
};
